import { inject, Pipe, PipeTransform } from '@angular/core';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';

@Pipe({
  name: 'getMonthShortName',
  standalone: true
})
export class GetMonthShortNamePipe implements PipeTransform {
  private datepickerI18n = inject(NgbDatepickerI18n);

  transform(month: number): string {
    if (month >= 1 && month <= 12) {
      return this.datepickerI18n.getMonthShortName(month);
    }
    return '';
  }
}
